function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { LONG_TASK, LARGEST_CONTENTFUL_PAINT, FIRST_CONTENTFUL_PAINT, FIRST_INPUT, LAYOUT_SHIFT } from '../../common/constants';
import { noop, PERF, isPerfTypeSupported, isRedirectInfoAvailable } from '../../common/utils';
import Span from '../span';
export var metrics = {
  fid: 0,
  fcp: 0,
  tbt: {
    start: Infinity,
    duration: 0
  },
  cls: {
    score: 0,
    firstEntryTime: Number.NEGATIVE_INFINITY,
    prevEntryTime: Number.NEGATIVE_INFINITY,
    currentSessionScore: 0
  },
  longtask: {
    count: 0,
    duration: 0,
    max: 0
  }
};
var LONG_TASK_THRESHOLD = 50;
export function createLongTaskSpans(longtasks, agg) {
  var spans = [];
  for (var i = 0; i < longtasks.length; i++) {
    var _longtasks$i = longtasks[i],
      name = _longtasks$i.name,
      startTime = _longtasks$i.startTime,
      duration = _longtasks$i.duration,
      attribution = _longtasks$i.attribution;
    var end = startTime + duration;
    var span = new Span("Longtask(" + name + ")", LONG_TASK, {
      startTime: startTime
    });
    agg.count++;
    agg.duration += duration;
    agg.max = Math.max(duration, agg.max);
    if (attribution.length > 0) {
      var _attribution$ = attribution[0],
        _name = _attribution$.name,
        containerType = _attribution$.containerType,
        containerName = _attribution$.containerName,
        containerId = _attribution$.containerId;
      var customContext = {
        attribution: _name,
        type: containerType
      };
      if (containerName) {
        customContext.name = containerName;
      }
      if (containerId) {
        customContext.id = containerId;
      }
      span.addContext({
        custom: customContext
      });
    }
    span.end(end);
    spans.push(span);
  }
  return spans;
}
export function createFirstInputDelaySpan(fidEntries) {
  var firstInput = fidEntries[0];
  if (firstInput) {
    var startTime = firstInput.startTime,
      processingStart = firstInput.processingStart;
    var span = new Span('First Input Delay', FIRST_INPUT, {
      startTime: startTime
    });
    span.end(processingStart);
    return span;
  }
}
export function createTotalBlockingTimeSpan(tbtObject) {
  var start = tbtObject.start,
    duration = tbtObject.duration;
  var tbtSpan = new Span('Total Blocking Time', LONG_TASK, {
    startTime: start
  });
  tbtSpan.end(start + duration);
  return tbtSpan;
}
export function calculateTotalBlockingTime(longtaskEntries) {
  longtaskEntries.forEach(function (entry) {
    var name = entry.name,
      startTime = entry.startTime,
      duration = entry.duration;
    if (startTime < metrics.fcp) {
      return;
    }
    if (name !== 'self' && name.indexOf('same-origin') === -1) {
      return;
    }
    metrics.tbt.start = Math.min(metrics.tbt.start, startTime);
    var blockingTime = duration - LONG_TASK_THRESHOLD;
    if (blockingTime > 0) {
      metrics.tbt.duration += blockingTime;
    }
  });
}
export function calculateCumulativeLayoutShift(clsEntries) {
  clsEntries.forEach(function (entry) {
    if (!entry.hadRecentInput && entry.value) {
      var shouldCreateNewSession = entry.startTime - metrics.cls.firstEntryTime > 5000 || entry.startTime - metrics.cls.prevEntryTime > 1000;
      if (shouldCreateNewSession) {
        metrics.cls.firstEntryTime = entry.startTime;
        metrics.cls.currentSessionScore = 0;
      }
      metrics.cls.prevEntryTime = entry.startTime;
      metrics.cls.currentSessionScore += entry.value;
      metrics.cls.score = Math.max(metrics.cls.score, metrics.cls.currentSessionScore);
    }
  });
}
export function captureObserverEntries(list, _ref) {
  var isHardNavigation = _ref.isHardNavigation,
    trStart = _ref.trStart;
  var longtaskEntries = list.getEntriesByType(LONG_TASK).filter(function (entry) {
    return entry.startTime >= trStart;
  });
  var longTaskSpans = createLongTaskSpans(longtaskEntries, metrics.longtask);
  var result = {
    spans: longTaskSpans,
    marks: {}
  };
  if (!isHardNavigation) {
    return result;
  }
  var lcpEntries = list.getEntriesByType(LARGEST_CONTENTFUL_PAINT);
  var lastLcpEntry = lcpEntries[lcpEntries.length - 1];
  if (lastLcpEntry) {
    var lcp = parseInt(lastLcpEntry.startTime);
    metrics.lcp = lcp;
    result.marks.largestContentfulPaint = lcp;
  }
  var timing = PERF.timing;
  var unloadDiff = timing.fetchStart - timing.navigationStart;
  if (isRedirectInfoAvailable(timing)) {
    unloadDiff = 0;
  }
  var fcpEntry = list.getEntriesByName(FIRST_CONTENTFUL_PAINT)[0];
  if (fcpEntry) {
    var fcp = parseInt(unloadDiff >= 0 ? fcpEntry.startTime - unloadDiff : fcpEntry.startTime);
    metrics.fcp = fcp;
    result.marks.firstContentfulPaint = fcp;
  }
  var fidEntries = list.getEntriesByType(FIRST_INPUT);
  var fidSpan = createFirstInputDelaySpan(fidEntries);
  if (fidSpan) {
    metrics.fid = fidSpan.duration();
    result.spans.push(fidSpan);
  }
  calculateTotalBlockingTime(longtaskEntries);
  var clsEntries = list.getEntriesByType(LAYOUT_SHIFT);
  calculateCumulativeLayoutShift(clsEntries);
  return result;
}
export var PerfEntryRecorder = function () {
  function PerfEntryRecorder(callback) {
    this.po = {
      observe: noop,
      disconnect: noop
    };
    if (window.PerformanceObserver) {
      this.po = new PerformanceObserver(callback);
    }
  }
  var _proto = PerfEntryRecorder.prototype;
  _proto.start = function start(type, options) {
    if (options === void 0) {
      options = {
        buffered: true
      };
    }
    try {
      if (!isPerfTypeSupported(type)) {
        return;
      }
      this.po.observe(_extends({
        type: type
      }, options));
    } catch (_) {}
  };
  _proto.stop = function stop() {
    this.po.disconnect();
  };
  return PerfEntryRecorder;
}();